// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepper-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 2rem;
}

.stepper-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1 1;
  z-index: 0;
}

.stepper-circle {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #f8f9fa;
  border: 2px solid #dee2e6;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
}

.stepper-circle i {
  color: #D7A04C;
}

.stepper-circle.active {
  background-color: #D7A04C;
  border-color: #D7A04C;
  color: white !important;
}

.stepper-circle.active i {
  color: white;
}

.stepper-circle.completed {
  background-color: #198754;
  border-color: #198754;
  color: white !important;
}

.stepper-label {
  font-size: 0.875rem;
  font-weight: 500;
  text-align: center;
}

.stepper-line {
  position: absolute;
  top: 25px;
  left: 50%;
  width: 100%;
  height: 2px;
  background-color: #dee2e6;
  z-index: -1;
}

.payment-method-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.payment-method-card:hover {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.payment-method-card.border-primary {
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
`, "",{"version":3,"sources":["webpack://./src/components/eCommerce/CartStepper/CartStepper.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;EACP,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":[".stepper-nav {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  margin-bottom: 2rem;\n}\n\n.stepper-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex: 1;\n  z-index: 0;\n}\n\n.stepper-circle {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  background-color: #f8f9fa;\n  border: 2px solid #dee2e6;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0.5rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n.stepper-circle i {\n  color: #D7A04C;\n}\n\n.stepper-circle.active {\n  background-color: #D7A04C;\n  border-color: #D7A04C;\n  color: white !important;\n}\n\n.stepper-circle.active i {\n  color: white;\n}\n\n.stepper-circle.completed {\n  background-color: #198754;\n  border-color: #198754;\n  color: white !important;\n}\n\n.stepper-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  text-align: center;\n}\n\n.stepper-line {\n  position: absolute;\n  top: 25px;\n  left: 50%;\n  width: 100%;\n  height: 2px;\n  background-color: #dee2e6;\n  z-index: -1;\n}\n\n.payment-method-card {\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.payment-method-card:hover {\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.payment-method-card.border-primary {\n  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
